import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { DataTableRow, DataTableRowProps } from './DataTableRow'

type SortableDataTableRowProps<TRow, TColumnId extends string> = DataTableRowProps<TRow, TColumnId> & {
    isDragDisabled?: boolean
}

export const SortableDataTableRow = <TRow, TColumnId extends string>({
    isDragDisabled = false,
    ...props
}: SortableDataTableRowProps<TRow, TColumnId>) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: props.rowId,
        disabled: isDragDisabled,
        attributes: { role: 'row' },
    })

    return (
        <DataTableRow
            {...props}
            drag={
                isDragDisabled
                    ? undefined
                    : {
                          setNodeRef,
                          isDragging,
                          style: transform
                              ? { transform: `translate3d(0, ${transform.y}px, 0)`, transition }
                              : { transition },
                          handleProps: { ...attributes, ...listeners },
                      }
            }
        />
    )
}

export default SortableDataTableRow
